export default __webpack_public_path__ + "static/media/loader.d3d158a1.svg";